@if (
showSection
) {
<header class="style-light header-compact" [class]="!  (stick && sticky) ? class : ''" [ngClass]="stick && sticky ? 'sticky fixed' : ''">
  <!-- @if(data?.header?.page_top_bar_enable){
    <app-top-bar [data]="data"></app-top-bar>
  } -->
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="main-menu">
          <div class="menu-left">
            <!-- <div class="toggle-nav" (click)="mainMenuOpen()">
              <i class="ri-menu-line sidebar-bar">
              </i>
            </div> -->
            <div class="brand-logo">
              <app-header-logo [logo]="logo"></app-header-logo>
            </div>
          </div>
          <div>
            <app-search [style]="'simple'"></app-search>
          </div>
          <div class="menu-right pull-right">
            <div>
              <div class="icon-nav">
                <ul>
                  <li class="onhover-div">
                    <a href="javascript:void(0)" [routerLink]="['/wishlist']">
                      <i class="ri-heart-line">
                      </i>
                    </a>
                  </li>
                  <li class="onhover-div">
                    <app-cart></app-cart>
                  </li>
                  <li class="onhover-div onhover-dropdown mobile-cart">
                    <app-user-profile></app-user-profile>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-part bottom-light">
    <div class="container">
      <div class="row">
        <div class="col-12 menu-row">
          <div class="main-menu-right">
            <app-menu></app-menu>
          </div>
          <div class="delivery-area d-xl-flex d-none ms-auto me-0">
            <div>
              <h5>{{ 'call_us' | translate }}: {{data?.header?.support_number}}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
}